const $ = window.jQuery

export function initAddressForms() {
  const $addAddressBtn = $('[data-show-address-form]');
  const $cancelLink = $('[data-cancel-address-form]');

  $addAddressBtn.click(function () {
    $(this).parent().nextAll('.account-address-form').addClass('show')
  })

  $cancelLink.click(function (e) {
    e.preventDefault();
    $(this).parents('.account-address-form').removeClass('show')
  })

  // Confirm delete before submitting
  document.querySelectorAll('.address-delete-form').forEach((deleteForm) => {
    deleteForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const confirmMessage = event.target.getAttribute('data-confirm-message');

      const $confirm = $('#remove-item-dialog')
      $confirm.find('.modal-title').text(confirmMessage)
      $confirm.one('hide.bs.modal', function () {
      })
      $confirm.find('.btn-yes').one('click', function () {
        deleteForm.submit()
      })
      $confirm.modal('show')
    });
  });

  // redirect back to '/account' after submitting address forms
  if (window.location.pathname === '/account/addresses') {
    window.location.replace('/account');
  }

}
